import { RHFMultiSelectSegmented } from '@/shared/components/HookForm'

import { useCompetitorOptions } from '../../../lib/useCompetitorOptions'
import { FieldLoadError } from './FieldLoadError'

/** Special param type: multiple competitors from the remote (global) list. */
export const CompetitorListField = ({
	name,
	label,
	testId,
	context,
}: {
	name: string
	label: string
	testId?: string
	context?: {
		optimizationGroupId?: string
	}
}) => {
	const { options, isLoading, isError, refetch } = useCompetitorOptions({
		context,
	})

	if (isError)
		return <FieldLoadError label={label} onRetry={refetch} testId={testId} />

	// Segmented (not plain RHFMultiSelect) for the All/Selected filter the
	// schema-driven form had before the rule builder. Keep virtualization on —
	// only that branch actually filters the Selected tab.
	// RHFMultiSelectSegmented has no testId prop — scope it with a wrapper.
	return (
		<div data-testid={testId}>
			<RHFMultiSelectSegmented
				name={name}
				defaultValue={[]}
				label={label}
				options={options}
				isLoading={isLoading}
				disabled={isLoading}
			/>
		</div>
	)
}
